import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link ,useNavigate} from 'react-router-dom';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function Viewsales() {

    const location = useLocation();
    const navigate=useNavigate();
    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
    const [orderData, setOrderData] = useState('');
    const [orderId, setOrderId] = useState(null);
    const [formData, setFormData] = useState({});
    const [paymentStatus, setPaymentStatus] = useState(orderData?.length > 0 ? orderData[0]?.paymentStatus : "notPaid");


    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);

        setFormData((prevData) => ({
            ...prevData,
            ['empId']: userID,
            ['orderId']: orderid
        }));
    }, [userID]);

	
    const getOrderData = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/invoice/order-details/', {orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setOrderData(response.data.data);

                setFormData((prevData) => ({
                    ...prevData,
                    ['status']: response.data.data[0]?.status,
                }));
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	 
    

    
    const handleDownloadInvoice = () => {
        navigate("/get-Invoice", { state: { orderId } });
    };
    //console.log(formData);
    useEffect(() => {
        if (orderData.length > 0) {
            setPaymentStatus(orderData[0]?.paymentStatus || "notPaid");
        }
    }, [orderData]);

    
    const updatePayment = async (status) => {
        // setPaymentStatus(status);
        console.log("status", status);
        try {
            const response = await axios.post('https://api.trucoo.in/invoice/payment/', {orderId: orderId, paymentStatus: status}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if (response.data.status === 'success') {
               alert("payment status updated")
               setPaymentStatus(status);
               getOrderData();
                
            }
        } catch (error) {
            console.log("Error:", error.response || error.message);
        }
    }
    useEffect(() => {
        getOrderData();
    }, [orderId]);



return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">

			<div class="box">
                <div class="box-header with-border">
				  <h4 class="box-title">Order Details</h4>
				  <p class="mb-0 box-subtitle">{orderId}</p>
				</div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-lg-12 mt-4">
                            <div class="row">
                                <div class="col-lg-4 mt-2">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                          <tr>
                                            <td width="35%" style={{padding: '5px'}}>Client Name</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.name}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Company Name</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.companyName}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Address</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.companyAddress}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>GST</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.gst}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-4 mt-2">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                        <tr>
                                            <td width="35%" style={{padding: '5px'}}>Email</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.email}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Company Phone</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.companyContact}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Alternate Phone</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.phone}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Location</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.clientData?.location}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-4 mt-2">
                                    <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                        <table width="100%">
                                          <tr>
                                            <td width="35%" style={{padding: '5px'}}>Placed On</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.orderDate}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Delivery Date</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.deliveryDate}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Delivered On</td>
                                            <td style={{padding: '5px'}}>{orderData[0]?.deliveredDate}</td>
                                          </tr>
                                          <tr>
                                            <td style={{padding: '5px'}}>Order Value</td>
                                            <td style={{padding: '5px'}}>₹ {Number(orderData[0]?.totalPayment).toFixed(2)}</td>
                                          </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-lg-8 mt-2">
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Order Items</p>
				            </div>
				            <div class="box-body">
					            <div class="table-responsive">
					                <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						                <thead>
							                <tr class="text-dark">
								                <th>Item</th>
								                <th>Qty</th>
								                <th>Price</th>
								                <th>Amount</th>
							                </tr>
                                        </thead>
						                <tbody>
							                {orderData.length > 0 ? orderData[0]?.orderData.map((item, index) =>
							                    <tr key={index}>
								                    <td class="text-dark">{item.Item}</td>
								                    <td>{item.qty}</td>
								                    <td>₹ {Number(item.price).toFixed(2)}</td>
								                    <td>₹ {Number(item.subtotal).toFixed(2)}</td>
							                    </tr>
							                ):(
								                <tr>
									                <td colSpan={6}>No Order Details Data</td>
								                </tr>
							                )}
							
						                </tbody>	
					                </table>
					            </div>              
				            </div>  

                        </div>

                        <div class="col-lg-4 mt-4">
                            <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                <table width="100%">
                                    <tr>
                                        <p class="text-center">Remarks</p>
                                        <p>{orderData[0]?.comments}</p>
                                    </tr>
                                </table>
                            </div>

                            <table width="100%" class="mt-4">
                                <tr>
                                    <td style={{padding: '5px'}}>Order Value</td>
                                    <td style={{padding: '5px'}}>₹ {(Number(orderData[0]?.totalPayment) - Number(orderData[0]?.gst)).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td style={{padding: '5px'}}>GST</td>
                                    <td style={{padding: '5px'}}>₹ {Number(orderData[0]?.gst).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td style={{padding: '5px'}}>Advance Payment</td>
                                    <td style={{padding: '5px'}}>₹ {Number(orderData[0]?.advancePayment).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <th style={{padding: '5px'}}>Balance Payment</th>
                                    <th style={{padding: '5px'}}>₹ {Number(orderData[0]?.balancePayment).toFixed(2)}</th>
                                </tr>
                            </table>
                            <div className="form-group mt-2">
                            <div className="col-lg-4 mt-4">
    <label>Payment Status:</label>
    <select 
        className="form-control"
        value={paymentStatus} 
        onChange={(e) => updatePayment(e.target.value)}
    >
        <option value="notPaid">Not Paid</option>
        <option value="paid">Paid</option>
    </select>
</div>


            
            

            <div className="col-lg-12 mt-4" align="center">
                {paymentStatus === 'notPaid' ? (
                    <button className="btn btn-success" onClick={() => updatePayment('paid')}>
                        Update Payment Status
                    </button>
                ) : (
                    <button className="btn btn-success" onClick={handleDownloadInvoice}>
                        View Invoice
                    </button>
                )}
            </div>
        </div>

                            <hr />
                            
                         

                            
                        </div>



                       
                        
                    </div>
                </div>


				
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default Viewsales;